module.exports = __webpack_public_path__ + "static/media/BANNER_PLAN_SILVERS_328x230_mobile.4d6ac331.jpg";